var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"logo-card"},[_c('div',{staticClass:"bg-logo"}),_c('h1',{staticClass:"text-primary welcome-text mt-5"},[_vm._v("Welcome to "+_vm._s(_vm.appName))])])}
var staticRenderFns = []

export { render, staticRenderFns }